import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web

const persistorConfig = {
  key: 'backoffice-helpcenter',
  storage,
  blacklist: ['configuration', 'document', 'option', 'faq', 'step', 'search'],
  whitelist: ['category'],
  // blacklist: ['configuration', 'document', 'option', 'faq', 'step', 'auth'],
};

export default persistorConfig;
